/**
 * Defines the structure of a ticker item
 */
export interface TickerType {
  t: string; // Ticker Symbol
  n: string; // Name
  s: string; // Sector
  i: string; // Industry
}

/**
 * Fetches the list of stock tickers from the API endpoint
 * @returns Promise containing an array of ticker items
 */
export async function getTickerList(): Promise<TickerType[]> {
  try {
    const response = await fetch('/api/v1/tickers');

    if (!response.ok) {
      throw new Error(`Failed to fetch tickers: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data as TickerType[];
  } catch (error) {
    console.error('Error fetching ticker list:', error);
    // Fallback to static file if API fails
    try {
      const fallbackResponse = await fetch('/tickers.json');
      if (fallbackResponse.ok) {
        const fallbackData = await fallbackResponse.json();
        return fallbackData as TickerType[];
      }
    } catch (fallbackError) {
      console.error('Fallback to static file also failed:', fallbackError);
    }
    return [];
  }
}
